module.exports = __webpack_public_path__ + "static/media/guest-new-question.45445f0d.gif";